// extracted by mini-css-extract-plugin
export var smallSpinner = "_q8-0";